// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./tokens/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./pane-overlays.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./toolbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./settings.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./chart-splitter.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./header.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./paper-trade.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./drawing.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./overlays.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./replay.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./floating-chart-bar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-01: Widget CSS root file.
 *
 * CSS variables for theme support + root class for widget namespace.
 * Import this file once in the widget bundle or host app.
 *
 * NOTE: Theme CSS variables are now the SSOT in tokens/colors.css.
 *       This file only holds layout, reset, and component styles.
 */

/* ── Token imports (SSOT) ─────────────────────────────────────────── */

/* ── Pane header, tooltip, label, series picker ──────────────────── */

/* ── Drawing toolbar (tools, buttons, flyout, auto-hide shell) ───── */

/* ── Settings modal & Snapshot preview ───────────────────────────── */

/* ── Pane splitter (resize panes) ────────────────────────────────── */

/* ── OHLC header bar (symbol, price, change) ────────────────────── */

/* ── Timeframe footer (TF chips, range chips) ───────────────────── */

/* ── Paper trade panel (sidebar) ────────────────────────────────── */

/* ── Drawing dock, inspector, paper trade panel (docked) ────────── */

/* ── Tape panel & Advisory panel ────────────────────────────────── */

/* ── Replay control bar ─────────────────────────────────────────── */

/* ── Floating chart control bar (auto-hide; visuals in .module.css) ── */

/* ── Sync button theme overrides ───────────────────────────────────── */
/* NOTE: MultiChartsFooter.module.css lives under components/footer/ which is
   outside the CSS module build scan path (src/widget/styles/*.module.css only).
   These rules provide the light-theme override that would otherwise be orphaned
   in dist/index.css (never loaded at runtime — only injected.css is). */
[data-chart-mode=light] .MultiChartsFooter_syncBtn {
  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));
  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));
  color: var(--vnsc-text-primary, #1a1a1a);
}
[data-chart-mode=light] .MultiChartsFooter_syncBtn:hover {
  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));
  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));
  color: var(--vnsc-text-primary, #1a1a1a);
}
[data-chart-mode=light] .MultiChartsFooter_syncBtnActive {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));
  border-color: var(--vnsc-accent, #6366f1);
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtn {
  padding: 4px 10px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: var(--vnsc-font-size-2xs, 10px);
  font-weight: 500;
  transition: all 0.15s ease;
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtn:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));
  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtnActive {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));
  border-color: var(--vnsc-accent, #6366f1);
  font-weight: 600;
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);
}

/* ── Reset scoped strictly to widget subtree ──────────────────────── */
/* Only applies to elements that are children of .vnsc-root (the widget's root div).
   Does NOT affect the host app / demo shell layout. */
.vnsc-root {
	box-sizing: border-box;
	overflow: hidden;
	user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
}
.vnsc-root input,
.vnsc-root select,
.vnsc-root textarea {
	user-select: text;
	-webkit-user-select: text;
	-ms-user-select: text;
}
.vnsc-root > *,
.vnsc-root > *::before,
.vnsc-root > *::after {
	box-sizing: border-box;
}

/* ── Shared button style ──────────────────────────────────────────── */
.vnsc-root .vnsc-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: none;
	border-radius: var(--vnsc-radius-md);
	cursor: pointer;
	font-family: inherit;
	font-weight: 600;
	transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}

.vnsc-root .vnsc-btn:hover {
	background: var(--vnsc-accent-hover);
	color: #fff;
}

.vnsc-root .vnsc-btn:active {
	transform: scale(0.97);
}

.vnsc-root .vnsc-btn:focus-visible {
	outline: var(--vnsc-focus-ring);
	outline-offset: var(--vnsc-focus-ring-offset);
}

/* ── Shared chip style ────────────────────────────────────────────── */
.vnsc-root .vnsc-chip {
	padding: 3px 8px;
	border: 1px solid transparent;
	border-radius: var(--vnsc-radius-md);
	cursor: pointer;
	font-size: var(--vnsc-font-sm);
	font-weight: 500;
	background: transparent;
	color: var(--vnsc-text-secondary);
	transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
}

.vnsc-root .vnsc-chip:hover {
	color: var(--vnsc-text-primary);
	border-color: rgba(255, 255, 255, 0.12);
}

.vnsc-root .vnsc-chip--active {
	color: var(--vnsc-text-primary);
	font-weight: 600;
	border-color: rgba(255, 255, 255, 0.18);
}

.vnsc-root .vnsc-chip--active:hover {
	border-color: rgba(255, 255, 255, 0.25);
}

/* ── Separator ────────────────────────────────────────────────────── */
.vnsc-root .vnsc-sep {
	width: 1px;
	height: 16px;
	background: var(--vnsc-border);
}

/* ── Scrollbar ────────────────────────────────────────────────────── */
.vnsc-root ::-webkit-scrollbar {
	width: 6px;
}

.vnsc-root ::-webkit-scrollbar-track {
	background: transparent;
}

.vnsc-root ::-webkit-scrollbar-thumb {
	background: var(--vnsc-border);
	border-radius: var(--vnsc-radius-sm);
}

.vnsc-root ::-webkit-scrollbar-thumb:hover {
	background: var(--vnsc-text-muted);
}

/* ── Font & Typography reset (WP-11) ────────────────────────────────── */
.vnsc-root,
.vnsc-root input,
.vnsc-root select,
.vnsc-root textarea,
.vnsc-root button {
	font-family: "Inter", var(--gc-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif) !important;
}

/* ── Unified Right Sidebar & Splitter ───────────────────────────────── */
.vnsc-root .vnsc-sidebar-splitter {
	position: relative;
	width: 4px;
	height: 100%;
	cursor: col-resize;
	z-index: 49;
	background: transparent;
	transition: background var(--vnsc-transition-fast);
}
.vnsc-root .vnsc-sidebar-splitter:hover {
	background: var(--vnsc-accent, #2962ff) !important;
}

.vnsc-root .vnsc-sidebar-right {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: var(--vnsc-bg-secondary);
	border-left: 1px solid var(--vnsc-border);
	position: relative;
	z-index: 48;
	min-width: 150px;
	overflow-y: auto;
}

/* Override absolute positioning of panels inside sidebar */
.vnsc-root .vnsc-sidebar-right .vnsc-drawing-dock,
.vnsc-root .vnsc-sidebar-right .vnsc-paper-trade-panel,
.vnsc-root .vnsc-sidebar-right .vnsc-advisory-panel,
.vnsc-root .vnsc-sidebar-right .vnsc-tape-panel {
	position: relative !important;
	top: auto !important;
	bottom: auto !important;
	right: auto !important;
	left: auto !important;
	width: 100% !important;
	height: auto !important;
	flex: 1 1 0% !important;
	min-height: 140px !important;
	border-left: none !important;
	border-right: none !important;
	z-index: auto !important;
	background: transparent !important;
}

/* Add bottom border separating panels in sidebar */
.vnsc-root .vnsc-sidebar-right > div:not(:last-child) {
	border-bottom: 1px solid var(--vnsc-border) !important;
}

/* ── Spinner (empty-state loading) ────────────────────────────────── */
@keyframes vnsc-spin {
	to { transform: rotate(360deg); }
}
.vnsc-root .vnsc-spinner {
	width: 16px;
	height: 16px;
	border-radius: 50%;
	border: 2px solid currentColor;
	border-top-color: transparent;
	animation: vnsc-spin 1s linear infinite;
}

/* Fullscreen mode support overrides */
.vnsc-root:fullscreen {
	background-color: var(--vnsc-bg-primary, #0a0e14) !important;
	width: 100vw !important;
	height: 100vh !important;
	padding: 0 !important;
}

/*
 * Upsell / locked feature (PRICING 2026-10-22).
 *
 * \`.vnsc-locked-feature\` la nut upsell cua CapabilityGate. Truoc day class nay KHONG
 * co style gi (chi co trong TSX) => nut render khong style, va khong hien duoc
 * GOI hay GIA. Bai nay them style + dong "Goi - Gia" de gia 199.000d/thang cua
 * goi Pro co cho ai nhin thay.
 *
 * Token only (design rule D2: 0 hex tho ngoai token) - fallback trong \`var()\` chi
 * la gia tri cuoi cung cho host chua nap token.
 */
.vnsc-root .vnsc-locked-feature {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
	border-radius: 6px;
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
	color: var(--vnsc-text-primary, #d1d4dc);
	font: inherit;
	font-size: 12px;
	line-height: 1.35;
	cursor: pointer;
	text-align: left;
}
.vnsc-root .vnsc-locked-feature:hover {
	background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));
	border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.12));
}
.vnsc-root .vnsc-locked-feature:focus-visible {
	outline: 2px solid var(--vnsc-focus-ring, var(--vnsc-accent, #6366f1));
	outline-offset: 2px;
}
.vnsc-root .vnsc-locked-feature__icon {
	font-size: 12px;
	line-height: 1;
}
.vnsc-root .vnsc-locked-feature__label {
	white-space: nowrap;
}
/* Dong "Goi Pro - 199.000d/thang": dong thong tin gia, khong phai nut rieng. */
.vnsc-root .vnsc-locked-feature__plan {
	color: var(--vnsc-text-secondary, #787b86);
	white-space: nowrap;
}
.vnsc-root .vnsc-locked-feature__price {
	color: var(--vnsc-accent, #6366f1);
	font-weight: 600;
	white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/widget.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF,wEAAwE;;AAGxE,uEAAuE;;AAGvE,uEAAuE;;AAGvE,uEAAuE;;AAGvE,uEAAuE;;AAGvE,sEAAsE;;AAGtE,sEAAsE;;AAGtE,sEAAsE;;AAGtE,sEAAsE;;AAGtE,sEAAsE;;AAGtE,sEAAsE;;AAGtE,yEAAyE;;AAGzE,yEAAyE;AACzE;;;wEAGwE;AACxE;EACE,qDAAqD;EACrD,qDAAqD;EACrD,wCAAwC;AAC1C;AACA;EACE,sDAAsD;EACtD,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,8DAA8D;EAC9D,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,+DAA+D;EAC/D,kBAAkB;EAClB,2DAA2D;EAC3D,0CAA0C;EAC1C,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,4DAA4D;EAC5D,iEAAiE;AACnE;AACA;EACE,2CAA2C;EAC3C,8DAA8D;EAC9D,yCAAyC;EACzC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,wEAAwE;AACxE;sDACsD;AACtD;CACC,sBAAsB;CACtB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,sBAAsB;AACvB;;AAEA,wEAAwE;AACxE;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,oCAAoC;CACpC,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,qFAAqF;AACtF;;AAEA;CACC,oCAAoC;CACpC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,+BAA+B;CAC/B,6CAA6C;AAC9C;;AAEA,wEAAwE;AACxE;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,oCAAoC;CACpC,eAAe;CACf,8BAA8B;CAC9B,gBAAgB;CAChB,uBAAuB;CACvB,iCAAiC;CACjC,uFAAuF;AACxF;;AAEA;CACC,+BAA+B;CAC/B,uCAAuC;AACxC;;AAEA;CACC,+BAA+B;CAC/B,gBAAgB;CAChB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;AACxC;;AAEA,wEAAwE;AACxE;CACC,UAAU;CACV,YAAY;CACZ,8BAA8B;AAC/B;;AAEA,wEAAwE;AACxE;CACC,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;AACrC;;AAEA;CACC,kCAAkC;AACnC;;AAEA,0EAA0E;AAC1E;;;;;CAKC,oIAAoI;AACrI;;AAEA,0EAA0E;AAC1E;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,uBAAuB;CACvB,kDAAkD;AACnD;AACA;CACC,kDAAkD;AACnD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,oCAAoC;CACpC,yCAAyC;CACzC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA,2DAA2D;AAC3D;;;;CAIC,6BAA6B;CAC7B,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,4BAA4B;CAC5B,4BAA4B;CAC5B,6BAA6B;CAC7B,wBAAwB;CACxB,kCAAkC;AACnC;;AAEA,mDAAmD;AACnD;CACC,sDAAsD;AACvD;;AAEA,wEAAwE;AACxE;CACC,KAAK,yBAAyB,EAAE;AACjC;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,8BAA8B;CAC9B,6BAA6B;CAC7B,uCAAuC;AACxC;;AAEA,sCAAsC;AACtC;CACC,4DAA4D;CAC5D,uBAAuB;CACvB,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;;;;;;;;;;EAUE;AACF;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;CACjB,+DAA+D;CAC/D,kBAAkB;CAClB,2DAA2D;CAC3D,wCAAwC;CACxC,aAAa;CACb,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,4DAA4D;CAC5D,iEAAiE;AAClE;AACA;CACC,sEAAsE;CACtE,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA,+EAA+E;AAC/E;CACC,0CAA0C;CAC1C,mBAAmB;AACpB;AACA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,mBAAmB;AACpB","sourcesContent":["/**\r\n * WE2 P4-01: Widget CSS root file.\r\n *\r\n * CSS variables for theme support + root class for widget namespace.\r\n * Import this file once in the widget bundle or host app.\r\n *\r\n * NOTE: Theme CSS variables are now the SSOT in tokens/colors.css.\r\n *       This file only holds layout, reset, and component styles.\r\n */\r\n\r\n/* ── Token imports (SSOT) ─────────────────────────────────────────── */\r\n@import \"./tokens/index.css\";\r\n\r\n/* ── Pane header, tooltip, label, series picker ──────────────────── */\r\n@import \"./pane-overlays.css\";\r\n\r\n/* ── Drawing toolbar (tools, buttons, flyout, auto-hide shell) ───── */\r\n@import \"./toolbar.css\";\r\n\r\n/* ── Settings modal & Snapshot preview ───────────────────────────── */\r\n@import \"./settings.css\";\r\n\r\n/* ── Pane splitter (resize panes) ────────────────────────────────── */\r\n@import \"./chart-splitter.css\";\r\n\r\n/* ── OHLC header bar (symbol, price, change) ────────────────────── */\r\n@import \"./header.css\";\r\n\r\n/* ── Timeframe footer (TF chips, range chips) ───────────────────── */\r\n@import \"./footer.css\";\r\n\r\n/* ── Paper trade panel (sidebar) ────────────────────────────────── */\r\n@import \"./paper-trade.css\";\r\n\r\n/* ── Drawing dock, inspector, paper trade panel (docked) ────────── */\r\n@import \"./drawing.css\";\r\n\r\n/* ── Tape panel & Advisory panel ────────────────────────────────── */\r\n@import \"./overlays.css\";\r\n\r\n/* ── Replay control bar ─────────────────────────────────────────── */\r\n@import \"./replay.css\";\r\n\r\n/* ── Floating chart control bar (auto-hide; visuals in .module.css) ── */\r\n@import \"./floating-chart-bar.css\";\r\n\r\n/* ── Sync button theme overrides ───────────────────────────────────── */\r\n/* NOTE: MultiChartsFooter.module.css lives under components/footer/ which is\r\n   outside the CSS module build scan path (src/widget/styles/*.module.css only).\r\n   These rules provide the light-theme override that would otherwise be orphaned\r\n   in dist/index.css (never loaded at runtime — only injected.css is). */\r\n[data-chart-mode=light] .MultiChartsFooter_syncBtn {\r\n  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));\r\n  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));\r\n  color: var(--vnsc-text-primary, #1a1a1a);\r\n}\r\n[data-chart-mode=light] .MultiChartsFooter_syncBtn:hover {\r\n  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));\r\n  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));\r\n  color: var(--vnsc-text-primary, #1a1a1a);\r\n}\r\n[data-chart-mode=light] .MultiChartsFooter_syncBtnActive {\r\n  color: var(--vnsc-text-on-primary, #ffffff);\r\n  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));\r\n  border-color: var(--vnsc-accent, #6366f1);\r\n}\r\n[data-chart-mode=dark] .MultiChartsFooter_syncBtn {\r\n  padding: 4px 10px;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: var(--vnsc-font-size-2xs, 10px);\r\n  font-weight: 500;\r\n  transition: all 0.15s ease;\r\n}\r\n[data-chart-mode=dark] .MultiChartsFooter_syncBtn:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));\r\n  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));\r\n}\r\n[data-chart-mode=dark] .MultiChartsFooter_syncBtnActive {\r\n  color: var(--vnsc-text-on-primary, #ffffff);\r\n  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));\r\n  border-color: var(--vnsc-accent, #6366f1);\r\n  font-weight: 600;\r\n  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);\r\n}\r\n\r\n/* ── Reset scoped strictly to widget subtree ──────────────────────── */\r\n/* Only applies to elements that are children of .vnsc-root (the widget's root div).\r\n   Does NOT affect the host app / demo shell layout. */\r\n.vnsc-root {\r\n\tbox-sizing: border-box;\r\n\toverflow: hidden;\r\n\tuser-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n}\r\n.vnsc-root input,\r\n.vnsc-root select,\r\n.vnsc-root textarea {\r\n\tuser-select: text;\r\n\t-webkit-user-select: text;\r\n\t-ms-user-select: text;\r\n}\r\n.vnsc-root > *,\r\n.vnsc-root > *::before,\r\n.vnsc-root > *::after {\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n/* ── Shared button style ──────────────────────────────────────────── */\r\n.vnsc-root .vnsc-btn {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tborder: none;\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tcursor: pointer;\r\n\tfont-family: inherit;\r\n\tfont-weight: 600;\r\n\ttransition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-root .vnsc-btn:hover {\r\n\tbackground: var(--vnsc-accent-hover);\r\n\tcolor: #fff;\r\n}\r\n\r\n.vnsc-root .vnsc-btn:active {\r\n\ttransform: scale(0.97);\r\n}\r\n\r\n.vnsc-root .vnsc-btn:focus-visible {\r\n\toutline: var(--vnsc-focus-ring);\r\n\toutline-offset: var(--vnsc-focus-ring-offset);\r\n}\r\n\r\n/* ── Shared chip style ────────────────────────────────────────────── */\r\n.vnsc-root .vnsc-chip {\r\n\tpadding: 3px 8px;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tcursor: pointer;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tfont-weight: 500;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary);\r\n\ttransition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-root .vnsc-chip:hover {\r\n\tcolor: var(--vnsc-text-primary);\r\n\tborder-color: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.vnsc-root .vnsc-chip--active {\r\n\tcolor: var(--vnsc-text-primary);\r\n\tfont-weight: 600;\r\n\tborder-color: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n.vnsc-root .vnsc-chip--active:hover {\r\n\tborder-color: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n/* ── Separator ────────────────────────────────────────────────────── */\r\n.vnsc-root .vnsc-sep {\r\n\twidth: 1px;\r\n\theight: 16px;\r\n\tbackground: var(--vnsc-border);\r\n}\r\n\r\n/* ── Scrollbar ────────────────────────────────────────────────────── */\r\n.vnsc-root ::-webkit-scrollbar {\r\n\twidth: 6px;\r\n}\r\n\r\n.vnsc-root ::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.vnsc-root ::-webkit-scrollbar-thumb {\r\n\tbackground: var(--vnsc-border);\r\n\tborder-radius: var(--vnsc-radius-sm);\r\n}\r\n\r\n.vnsc-root ::-webkit-scrollbar-thumb:hover {\r\n\tbackground: var(--vnsc-text-muted);\r\n}\r\n\r\n/* ── Font & Typography reset (WP-11) ────────────────────────────────── */\r\n.vnsc-root,\r\n.vnsc-root input,\r\n.vnsc-root select,\r\n.vnsc-root textarea,\r\n.vnsc-root button {\r\n\tfont-family: \"Inter\", var(--gc-font, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif) !important;\r\n}\r\n\r\n/* ── Unified Right Sidebar & Splitter ───────────────────────────────── */\r\n.vnsc-root .vnsc-sidebar-splitter {\r\n\tposition: relative;\r\n\twidth: 4px;\r\n\theight: 100%;\r\n\tcursor: col-resize;\r\n\tz-index: 49;\r\n\tbackground: transparent;\r\n\ttransition: background var(--vnsc-transition-fast);\r\n}\r\n.vnsc-root .vnsc-sidebar-splitter:hover {\r\n\tbackground: var(--vnsc-accent, #2962ff) !important;\r\n}\r\n\r\n.vnsc-root .vnsc-sidebar-right {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\tbackground: var(--vnsc-bg-secondary);\r\n\tborder-left: 1px solid var(--vnsc-border);\r\n\tposition: relative;\r\n\tz-index: 48;\r\n\tmin-width: 150px;\r\n\toverflow-y: auto;\r\n}\r\n\r\n/* Override absolute positioning of panels inside sidebar */\r\n.vnsc-root .vnsc-sidebar-right .vnsc-drawing-dock,\r\n.vnsc-root .vnsc-sidebar-right .vnsc-paper-trade-panel,\r\n.vnsc-root .vnsc-sidebar-right .vnsc-advisory-panel,\r\n.vnsc-root .vnsc-sidebar-right .vnsc-tape-panel {\r\n\tposition: relative !important;\r\n\ttop: auto !important;\r\n\tbottom: auto !important;\r\n\tright: auto !important;\r\n\tleft: auto !important;\r\n\twidth: 100% !important;\r\n\theight: auto !important;\r\n\tflex: 1 1 0% !important;\r\n\tmin-height: 140px !important;\r\n\tborder-left: none !important;\r\n\tborder-right: none !important;\r\n\tz-index: auto !important;\r\n\tbackground: transparent !important;\r\n}\r\n\r\n/* Add bottom border separating panels in sidebar */\r\n.vnsc-root .vnsc-sidebar-right > div:not(:last-child) {\r\n\tborder-bottom: 1px solid var(--vnsc-border) !important;\r\n}\r\n\r\n/* ── Spinner (empty-state loading) ────────────────────────────────── */\r\n@keyframes vnsc-spin {\r\n\tto { transform: rotate(360deg); }\r\n}\r\n.vnsc-root .vnsc-spinner {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid currentColor;\r\n\tborder-top-color: transparent;\r\n\tanimation: vnsc-spin 1s linear infinite;\r\n}\r\n\r\n/* Fullscreen mode support overrides */\r\n.vnsc-root:fullscreen {\r\n\tbackground-color: var(--vnsc-bg-primary, #0a0e14) !important;\r\n\twidth: 100vw !important;\r\n\theight: 100vh !important;\r\n\tpadding: 0 !important;\r\n}\r\n\r\n/*\r\n * Upsell / locked feature (PRICING 2026-10-22).\r\n *\r\n * `.vnsc-locked-feature` la nut upsell cua CapabilityGate. Truoc day class nay KHONG\r\n * co style gi (chi co trong TSX) => nut render khong style, va khong hien duoc\r\n * GOI hay GIA. Bai nay them style + dong \"Goi - Gia\" de gia 199.000d/thang cua\r\n * goi Pro co cho ai nhin thay.\r\n *\r\n * Token only (design rule D2: 0 hex tho ngoai token) - fallback trong `var()` chi\r\n * la gia tri cuoi cung cho host chua nap token.\r\n */\r\n.vnsc-root .vnsc-locked-feature {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 4px 10px;\r\n\tborder: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n\tborder-radius: 6px;\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tfont: inherit;\r\n\tfont-size: 12px;\r\n\tline-height: 1.35;\r\n\tcursor: pointer;\r\n\ttext-align: left;\r\n}\r\n.vnsc-root .vnsc-locked-feature:hover {\r\n\tbackground: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));\r\n\tborder-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.12));\r\n}\r\n.vnsc-root .vnsc-locked-feature:focus-visible {\r\n\toutline: 2px solid var(--vnsc-focus-ring, var(--vnsc-accent, #6366f1));\r\n\toutline-offset: 2px;\r\n}\r\n.vnsc-root .vnsc-locked-feature__icon {\r\n\tfont-size: 12px;\r\n\tline-height: 1;\r\n}\r\n.vnsc-root .vnsc-locked-feature__label {\r\n\twhite-space: nowrap;\r\n}\r\n/* Dong \"Goi Pro - 199.000d/thang\": dong thong tin gia, khong phai nut rieng. */\r\n.vnsc-root .vnsc-locked-feature__plan {\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\twhite-space: nowrap;\r\n}\r\n.vnsc-root .vnsc-locked-feature__price {\r\n\tcolor: var(--vnsc-accent, #6366f1);\r\n\tfont-weight: 600;\r\n\twhite-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
